module.exports = __webpack_public_path__ + "img/enfants.0a31f97f.jpg";